// AGREE
// ADD_APPROVE

import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Input, message, Form } from 'antd';
import { rejects, btnMap } from './conf';
import './action.scss';
import _ from 'lodash';
import { ProcessCatStore } from '../../store';
import {
    WidgetCommonObject,
    WidgetRadio,
} from '@/components/common/form/widgets';

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export const AgreeAddApproveAction: React.FC<{
    currentAction: string;
    data: any;
    onOk: (extra?: any) => void;
    onCancel: () => void;
    defaultStore: ProcessCatStore | null;
    loading: boolean;
}> = observer(
    ({ currentAction, data, onOk, onCancel, defaultStore, loading }) => {
        const [pass, setPass] = useState(true);
        const [useApprove, setUseApprove] = useState('0');
        const inputHelps: any = !pass
            ? {
                  validateStatus: 'error',
                  help: '加签人必填',
              }
            : {};
        if (!defaultStore?.defaultMeta) {
            return null;
        }

        const title = btnMap[currentAction] || '';
        const comment = data?.comment || '';
        const newTaskUser = data?.newTaskUser || null;
        const processBtns = defaultStore?.defaultMeta?.processBtns || [];
        const showAddApprove = processBtns.indexOf('ADD_APPROVE') > -1;
        const visible =
            currentAction === 'AGREE' && !!showAddApprove && data !== null;

        // 需要一个人员类型的字段元信息
        let ownerCol = null;
        if (defaultStore.defaultMeta) {
            ownerCol = _.find(
                defaultStore.defaultMeta.objectMeta,
                item => item.fieldName === 'create_user',
            );
        }

        if (!ownerCol) {
            return null;
        }
        const constraint = ownerCol.constraint;
        if (!constraint) {
            return null;
        }

        return (
            <Modal
                title={title}
                onOk={() => {
                    if (useApprove === '1' && newTaskUser === null) {
                        setPass(false);
                        return message.error('加签人必填');
                    }
                    onOk({ useApprove: useApprove === '1' });
                }}
                confirmLoading={loading}
                onCancel={onCancel}
                visible={visible}
                zIndex={10001}
            >
                <p>请填写审批意见</p>

                <div className="process-action">
                    <div className="form-wrapper">
                        <Form className="form" layout={'horizontal'}>
                            <Form.Item
                                {...formItemLayout}
                                label={<span className="label">审批意见</span>}
                            >
                                <Input.TextArea
                                    value={comment}
                                    onChange={e => {
                                        const text = e?.target?.value;
                                        if (!_.isUndefined(text)) {
                                            data.comment = text;
                                        }
                                    }}
                                    placeholder={'审批意见'}
                                ></Input.TextArea>
                            </Form.Item>

                            <Form.Item
                                {...formItemLayout}
                                label={<span className="label">加签</span>}
                            >
                                <WidgetRadio
                                    value={useApprove}
                                    options={{
                                        options: [
                                            {
                                                value: '1',
                                                label: '是',
                                            },
                                            {
                                                value: '0',
                                                label: '否',
                                            },
                                        ],
                                    }}
                                    onChange={v => {
                                        setUseApprove(v);
                                    }}
                                />
                            </Form.Item>

                            {useApprove === '1' ? (
                                <Form.Item
                                    {...formItemLayout}
                                    {...inputHelps}
                                    required
                                    label={
                                        <span className="label">加签人</span>
                                    }
                                >
                                    <WidgetCommonObject
                                        k={'create_user'}
                                        value={newTaskUser}
                                        onChange={val => {
                                            setPass(true);
                                            data.newTaskUser = val;
                                        }}
                                        options={{
                                            placeholder: '请选择加签人',
                                            constraint,
                                            listMeta: defaultStore.defaultMeta,
                                        }}
                                    />
                                </Form.Item>
                            ) : null}
                        </Form>
                    </div>
                </div>
            </Modal>
        );
    },
);
